<script context=module>
  export const typeToCollection = {
    media: "media",
    space: "spaces",
    vehicle: "vehicles",
    tenant: "tenants",
  };
</script>

<script>
  import { classes } from '../helpers';
  import Link from './Link.svelte';

  export let item;
  export let nolink = false;

  $: id = item && item.id;
  $: key = item && item.key;
  $: type = item && (item._type || item.type);
  $: format = item && item.format;
  $: display = item && item.display;

  $: linkId = id || key;
  $: href = nolink || !linkId || !typeToCollection[type]
    ? false
    : `./${typeToCollection[type]}/${linkId}`;
</script>

{#if item}
<Link {href}>
  <data class={classes(type, format, 'id')} value={id || key || ''}>
    <slot>{display}</slot>
  </data>
</Link>
{/if}
